<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6 form-group">
        <label v-if="!fields.is_parent" class="col-form-label pt-0 text-bold" for="child_sub_type">
          {{ $t('flexben.benefit.fields.child_sub_type')}}</label>
        <select v-if="!fields.is_parent" class="form-control" name="child_sub_type" id="child_sub_type"
                v-model="fields.child_sub_type">
          <option :value="null">-</option>
          <option :value="child_sub_type.id" v-for="child_sub_type in options.child_sub_types"
                  :key="child_sub_type.name">{{$t(child_sub_type.name)}}
          </option>
        </select>
        <div v-else class="form-control disabled">
          {{ $t('flexben.benefit.fields.is_parent')}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6 form-group">
        <label for="min_order_value" class="col-form-label">{{ $t('flexben.benefit.fields.min_order_value')
          }}</label>
        <input id="min_order_value" type="number" class="form-control" min="0" v-model="fields.min_order_value">
      </div>
      <div class="col-12 text-danger">{{ $t('flexben.benefit.fields.info_contract_number') }}</div>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-6 form-group" v-if="shouldShowRoiToggle">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center">
            <span id="roi_description"
                  class="d-inline-block flexben-tooltip-icon mr-2 text-bold">i</span>
            <b-tooltip :target="'roi_description'" variant="flexben" placement="topleft">
              <div class="text-left">{{ $t('flexben.benefit.fields.include_in_roi_report_hint') }}</div>
            </b-tooltip>
            <label for="include_in_roi_report" class="form-fields-required text-bold mb-0 col-form-label p-0" style="min-width: 200px">
              {{ $t('flexben.benefit.fields.include_in_roi_report') }}
            </label>
          </div>
          <b-form-checkbox id="include_in_roi_report"
                           class="ml-4"
                           v-model="fields.include_in_roi_report"
                           switch>
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {BFormCheckbox, BTooltip} from "bootstrap-vue";

export default {
  name: "BenefitPpp3FormFields",
  components: {
    'b-tooltip': BTooltip,
    "b-form-checkbox": BFormCheckbox,
  },
  props: {
    fields: {
      type: Object,
      default: function () {
        return {
          min_order_value: 100,
          child_sub_type : null
        };
      },
      required: true,
      child_sub_type: null
    },
    options: {
      type : Object,
      default: function () {
        return {};
      },
      required: true
    },
    errorsBag: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    },
    shouldShowRoiToggle: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log('BenefitPpp3FormFields: ', this.fields);
  }
}
</script>
